<template>
    <div class="w3-container">
        <h1>Dashboard</h1>
        
        <p>
            <strong>{{ $t('Latest record updates') }}</strong> 
            &nbsp;&nbsp;<button class="w3-button w3-tiny" @click="loadRecordUpdateLogEntries()">{{ $t('Refresh') }}</button>
        </p>
        <table class="w3-table twi-table">
            <thead>
                <tr>
                    <th>
                        <a href="javascript:void(0)" @click="setRecordUpdatesSortField('remote_address')">{{ $t('Remote Address') }}</a>
                        <img v-show="recordUpdatesSortField === 'remote_address' && recordUpdatesSortOrder === 'ASC'" src="@/assets/img/sort-asc-white-16.png" alt="ASC">
                        <img v-show="recordUpdatesSortField === 'remote_address' && recordUpdatesSortOrder === 'DESC'" src="@/assets/img/sort-desc-white-16.png" alt="DESC">
                    </th>
                    <th>
                        <a href="javascript:void(0)" @click="setRecordUpdatesSortField('action_time')">{{ $t('Time') }}</a>
                        <img v-show="recordUpdatesSortField === 'action_time' && recordUpdatesSortOrder === 'ASC'" src="@/assets/img/sort-asc-white-16.png" alt="ASC">
                        <img v-show="recordUpdatesSortField === 'action_time' && recordUpdatesSortOrder === 'DESC'" src="@/assets/img/sort-desc-white-16.png" alt="DESC">
                    </th>
                    <th>
                        <a href="javascript:void(0)" @click="setRecordUpdatesSortField('action_type')">{{ $t('Action') }}</a>
                        <img v-show="recordUpdatesSortField === 'action_type' && recordUpdatesSortOrder === 'ASC'" src="@/assets/img/sort-asc-white-16.png" alt="ASC">
                        <img v-show="recordUpdatesSortField === 'action_type' && recordUpdatesSortOrder === 'DESC'" src="@/assets/img/sort-desc-white-16.png" alt="DESC">
                    </th>
                    <th>
                        {{ $t('Details') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-show="recordUpdateLogEntries.length === 0">
                    <td colspan="6" class="w3-center"><strong>{{ $t('No record updates found.') }}</strong></td>
                </tr>

                <tr v-for="entry in recordUpdateLogEntries" :key="`${entry.remoteAddress}:${entry.actionTime}`">
                    <td class="w3-center">{{ entry.remoteAddress }}</td>
                    <td>{{ $datetime.format(entry.actionTime, null, $datetime.getDateTimeFormat()) }}</td>
                    <td class="w3-center">{{ $t(`actionLogEntryType.${entry.actionType}`) }}</td>
                    <td class="w3-small">{{ entry.actionDetails }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import '@/utils/DateTime'

import Api from 'Api'

import ActionLogEntry from '@/model/ActionLogEntry'

export default {
    name: 'Home',

    data () {
        return {
            recordUpdateLogEntries: [],
            recordUpdatesSortField: 'action_time',
            recordUpdatesSortOrder: 'DESC'
        }
    },

    mounted () {
        this.loadRecordUpdateLogEntries()
    },

    methods: {
        loadRecordUpdateLogEntries () {
            const self = this

            // Prepare parameters
            const sort = `${self.recordUpdatesSortField} ${self.recordUpdatesSortOrder}`

            // Query API
            Api.postRecordUpdateLog({}, 1, 10, sort)
                .then(resp => {
                    if (typeof resp.data !== 'object') {
                        window.toast({
                            text: self.$i18n.t('Invalid API response.'),
                            color: 'red'
                        })
                        return
                    }

                    const entries = []
                    try {
                        resp.data.forEach(it => entries.push(ActionLogEntry.fromObject(it)))
                    } catch (_err) {
                        console.debug(_err)
                        window.toast({
                            text: self.$i18n.t('Invalid API response.'),
                            color: 'red'
                        })
                        return
                    }
                    self.recordUpdateLogEntries = entries
                })
                .catch(err => {
                    if (typeof err.response === 'undefined' || typeof err.response.status !== 'number') {
                        window.toast({
                            text: self.$i18n.t('Invalid API response.'),
                            color: 'red'
                        })
                        return
                    }

                    let text = 'Invalid API response.'
                    switch (err.response.status) {
                    case 403:
                        text = 'You are not authorized to access action logs.'
                        break
                    
                    case 400:
                        let message = typeof err.response.data.message === 'string'
                            ? `:<br><tt>${err.response.data.message}</tt>`
                            : '.'
                        text = `Invalid request${message}`
                        break
                    default: // pass
                    }

                    window.toast({
                        text: self.$i18n.t(text),
                        color: 'red'
                    })
                })
        },

        setRecordUpdatesSortField (field) {
            if (this.recordUpdatesSortField === field) {
                this.recordUpdatesSortOrder = this.recordUpdatesSortOrder === 'ASC' ? 'DESC' : 'ASC'
            } else {
                this.recordUpdatesSortField = field
                this.recordUpdatesSortOrder = 'ASC'
            }
            this.loadRecordUpdateLogEntries()
        }
    }
}
</script>

<i18n src="@/lang/common.json"></i18n>
<i18n src="@/lang/dashboard.json"></i18n>
